import gql from 'graphql-tag';

export const CHECK_PAYMENT_STATUS = gql`
    mutation(
        $checkPaymentStatusInput: CheckPaymentStatusInput!
    ) {
        checkPaymentStatus (
            checkPaymentStatus: $checkPaymentStatusInput
        ) {
            response
            message
            status
            paidAmount
            paidAt
        }
    }
`;